import type { FC } from "react";
import type { ITableHeaderCellProps } from "../interfaces/ITableCellProps";
import styled from "styled-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const ColumnsContainer = styled(FlexRow)`
    justify-content: space-between;
    width: 100%;
`;

export const TwoColumnsHeaderCell: FC<ITableHeaderCellProps> = (props) => {
    const { leftCol, rightCol } = props;

    return (
        <ColumnsContainer>
            <div>{i18nFilter()(leftCol)}</div>
            <div>{i18nFilter()(rightCol)}</div>
        </ColumnsContainer>
    );
};
